import React from 'react';
import type { WebsiteContent } from '../../data/website';
interface MusicEditorCardProps {
  draft: WebsiteContent;
  update: <K extends keyof WebsiteContent>(key: K, value: WebsiteContent[K]) => void;
  Field: React.ComponentType<{
    label: string;
    value: string;
    onChange: (value: string) => void;
    helper?: string;
  }>;
  TextField: React.ComponentType<{
    label: string;
    value: string;
    onChange: (value: string) => void;
  }>;
  ImageField: React.ComponentType<{
    label: string;
    value: string;
    onChange: (value: string) => void;
    alt: string;
  }>;
}

/** Mirrors exactly what the public Music section renders: one image, one message, two links. */
export function MusicEditorCard({
  draft,
  update,
  Field,
  TextField,
  ImageField
}: MusicEditorCardProps) {
  return <div className="space-y-3" data-id="element-1115" data-mp="3s3r4h5w6jbx0">
      <ImageField label="Section image" value={draft.musicImageUrl} onChange={value => update('musicImageUrl', value)} alt="Music section image" data-id="element-1116" data-mp="1ca0kmzbb86dp" />
      <p className="text-[11px] leading-relaxed text-zinc-500" data-id="element-1117" data-mp="2um13a5wwfzbg">
        Shown as a large square beside the text. A square photo or album cover works best — uploads are resized
        automatically, or paste a hosted image URL.
      </p>

      <div className="grid gap-2 sm:grid-cols-2" data-id="element-1118" data-mp="34l9tqosk2vt2">
        <Field label="Eyebrow" value={draft.musicEyebrow} onChange={value => update('musicEyebrow', value)} data-id="element-1119" data-mp="38ltt7z0lqbid" />
        <Field label="Headline" value={draft.musicHeadline} onChange={value => update('musicHeadline', value)} data-id="element-1120" data-mp="2bvt6s6npg748" />
      </div>
      <TextField label="Description" value={draft.musicDescription} onChange={value => update('musicDescription', value)} data-id="element-1121" data-mp="2gvpcqbfyq8mf" />

      <div className="grid gap-2 sm:grid-cols-2" data-id="element-1122" data-mp="2kuepq2x39o5j">
        <Field label="Spotify button" value={draft.musicPrimaryLabel} onChange={value => update('musicPrimaryLabel', value)} data-id="element-1123" data-mp="2pnrag1yndat0" />
        <Field label="Spotify link" value={draft.musicPrimaryUrl} onChange={value => update('musicPrimaryUrl', value)} helper="Leave blank to hide this button." data-id="element-1124" data-mp="1t2z2q7rmdzes" />
        <Field label="Apple Music button" value={draft.musicSecondaryLabel} onChange={value => update('musicSecondaryLabel', value)} data-id="element-1125" data-mp="30f7xdupprqaa" />
        <Field label="Apple Music link" value={draft.musicSecondaryUrl} onChange={value => update('musicSecondaryUrl', value)} helper="Leave blank to hide this button." data-id="element-1126" data-mp="3a6ko2izs0aeq" />
      </div>
    </div>;
}